<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <!-- Bouton de rafraîchissement -->
        <b-row class="justify-content-start mb-5">
          <b-col cols="12" lg="12" xl="12" class="text-xl-center mb-3">
            <!--<vue-tabs v-model="tabName"
              active-tab-color="var(--actionButtonColor)"
              active-text-color="var(--actionTextColor)">
              <v-tab v-for="(tab, index) in tabs" :key="index"
                :title="index">
                <div slot="title">
                  {{ $t(tab.translationKey) }}
                </div>
              </v-tab>
            </vue-tabs>-->
            <b-button-group class="mt-3 mt-sm-0" style="display:grid;grid-auto-flow:column;">
              <b-button
                  class="responsive-button"
                  v-for="(tab, index) in tabs"
                  :key="index"
                  :variant="tabName === index ? 'primary' : 'secondary'"
                  @click="tabName = index">
                {{ $t(tab.translationKey) }}
              </b-button>
            </b-button-group>
          </b-col>
          <b-col cols="4" lg="2" xl="2">
            <b-button class="btnFilter"
              @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
              {{ $t('filter.fltr') }}
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="2">
            <b-button
              class="btnFilter"
              :disabled="activateSpinnerVopHistory || activateSpinnerVopMessage || activateSpinnerVopResponse"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="min-w-100 justify-content-start" :class="{'filter-item-section':true, 'd-none': !displayFilter}">
          <!-- Filtre StatusType -->
          <b-col sm="6" lg="3" cols="12" class="filter-item mb-5" v-if="tabName != 0 && !flagBPCE">
            <label for="monitoring-status">
              {{ $t('common.monitoring.status_type') }}
            </label>
            <select  class="form-control" v-model="StatusType" id="monitoring-status">
              <option value="" disabled>{{ $t('common.monitoring.select_placeholder') }}</option>
              <option value="ALL">{{ $t('common.monitoring.all') }}</option>
              <option value="DDV">{{ $t('common.monitoring.ddv_status') }}</option>
              <option value="DDD">{{ $t('common.monitoring.ddd_status') }}</option>
            </select>
          </b-col>
          <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
            <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
              :class="{'filter-item-input': true, 'filter-item-input-complete': dateStart}"
              :inputLabel="$t('common.monitoring.date_start')"
              customInputParentClass="filter-item-content"
              customInputClass="w-100"
              :maxLength="19"
              :placeholderValue="$t('common.datetime_picker_empty_date')"
              inputIcon="fa-solid fa-calendar"
              v-model="dateStart">
            </datetime-picker-custom>
          </b-col>
          <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
            <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
              :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd}"
              :inputLabel="$t('common.monitoring.date_end')"
              customInputParentClass="filter-item-content"
              customInputClass="w-100"
              :maxLength="19"
              :placeholderValue="$t('common.datetime_picker_empty_date')"
              inputIcon="fa-solid fa-calendar"
              v-model="dateEnd">
            </datetime-picker-custom>
          </b-col>
        </b-row>
        <b-row class="justify-content-end" :class="{'filter-item-section':true, 'd-none': !displayFilter}">
          <!-- Boutons Effacer et Appliquer -->
          <b-col sm="4" lg="2" cols="12" class="mt-4">
            <b-button class="mr-3" size="sm"
              @click="clearFilterFields">
              {{ $t('filter.clr_fltr_field') }}
            </b-button>
          </b-col>
          <b-col sm="4" lg="2" cols="12" class="mt-4">
            <b-button size="sm"
              @click="applyFilter">
              {{ $t('common.srch') }}
            </b-button>
          </b-col>
        </b-row>

        <b-row class="justify-content-end" :class="{'filter-item-section':true}">
          <b-col sm="4" lg="2" cols="12" class="mt-4">
            <div class="d-flex justify-content-end mt-5" v-if="listItemsResponse.length > 0 || listItemsMessage.length > 0 || listItemsHistory.length > 0">
              <b-button class="btnFilter_2 responsive-button2"
                        @click="extractXLSX()">
                <i class="fa-light fa-upload fs-14px"></i>
                <span class="fab-label">{{ $t('common.extract_page') }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-tabs v-model="tabName" @input="onTabChange" nav-class="d-none">
          <b-tab :title="$t('common.monitoring.distribution_vop_response_status')">
            <b-row class="justify-content-center mt-5">
              <spinner v-if="activateSpinnerVopResponse"></spinner>
              <b-col v-else-if="pieChartDataStatus" cols="12">
                <h3 class="text-center">
                  {{ $t("common.monitoring.distribution_vop_response_status") }}
                </h3>
                <pie-chart
                  ref="pieChartStatus"
                  :chart-data="pieChartDataStatus"
                  :options="chartOptionsStatus">
                </pie-chart>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab :title="$t('common.monitoring.time_distribution_by_processing_connector')">
            <b-row class="justify-content-center mt-5">
              <spinner v-if="activateSpinnerVopHistory"></spinner>
              <b-col v-else-if="pieChartDataConnector" cols="12">
                <h3 class="text-center">
                  {{ $t("common.monitoring.time_distribution_by_processing_connector") }}
                </h3>
                <pie-chart
                  ref="pieChartConnector"
                  :chart-data="pieChartDataConnector"
                  :options="chartOptionsConnector">
                </pie-chart>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab :title="$t('common.monitoring.distribution_of_requests')">
            <b-row class="justify-content-center mt-5">
              <spinner v-if="activateSpinnerVopMessage"></spinner>
              <b-col v-else-if="pieChartDataRequest" cols="12">
                <h3 class="text-center">
                  {{ $t("common.monitoring.distribution_of_requests") }}
                </h3>
                <pie-chart
                  ref="pieChartRequest"
                  :chart-data="pieChartDataRequest"
                  :options="chartOptionsRequest">
                </pie-chart>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab :title="$t('common.monitoring.average_duration_per_processing_step_messages')">
            <b-row class="justify-content-center mt-5">
              <spinner v-if="activateSpinnerVopHistory"></spinner>
              <b-col v-else-if="lineChartData" cols="12">
                <h3 class="text-center">
                  {{ $t("common.monitoring.average_duration_per_processing_step_messages") }}
                </h3>
                <line-chart
                  ref="lineChart"
                  :chart-data="lineChartData"
                  :options="chartOptionsLine">
                </line-chart>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </template>
  </page-outline>
</template>

<script>
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"
import { Chart as ChartJS } from "chart.js"
import { Line } from "vue-chartjs"
import { Pie } from "vue-chartjs"
import ChartDataLabels from "chartjs-plugin-datalabels"
import moment from "moment/moment"
import * as XLSX from 'xlsx'
import conf from "@/config/config.dev";

export default {
  name: "VopMessagePage",
  components: {
    'datetime-picker-custom': dateTimePicker,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner,
    "line-chart": {
      extends: Line,
      props: ["chartData", "options"],
      mounted() {
        // this.addPlugin(ChartDataLabels)
        this.renderChart(this.chartData, this.options)
      },
    },
    "pie-chart": {
      extends: Pie,
      props: ["chartData", "options"],
      mounted() {
        this.addPlugin(ChartDataLabels)
        this.renderChart(this.chartData, this.options)
      }
    }
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinnerVopHistory: false,
      activateSpinnerVopMessage: false,
      activateSpinnerVopResponse: false,
      chartOptionsConnector: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            bottom: 20
          }
        }
      },
      chartOptionsLine: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            type: "time",
            time: {
              unit: "hour",
            },
          },
        },
      },
      chartOptionsRequest: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                (a, b) => a + b,
                0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#fff",
            font: {
              weight: "bold",
            },
          }
        },
      },
      chartOptionsStatus: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                (a, b) => a + b,
                0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      dateEnd: '',
      dateStart: '',
      orgnlDateEnd: '',
      orgnlDateStart: '',
      orgnlStatusType: '',
      displayFilter: false,
      elementSearchedVopHistory: "",
      elementSearchedVopMessage: "",
      elementSearchedVopResponse: "",
      lineChartData: null,
      lineChartLabels: [],
      listItemsHistory: [],
      listItemsMessage: [],
      listItemsRequest: [],
      listItemsResponse: [],
      listTitle: "",
      flagBPCE: conf.visual != 'BPCE' ? false : true,
      pieChartDataConnector: null,
      pieChartDataStatus: null,
      pieChartDataRequest: null,
      refreshKey: false,
      StatusType: '',
      tabName: 0,
      tabs: [
        { translationKey: 'common.monitoring.distribution_vop_response_status' },
        // { translationKey: 'common.monitoring.time_distribution_by_processing_step' },
        { translationKey: 'common.monitoring.time_distribution_by_processing_connector' },
        { translationKey: 'common.monitoring.distribution_of_requests' },
        { translationKey: 'common.monitoring.average_duration_per_processing_step_messages' }
      ]
    }
  },
  computed: {},
  created() {
    // this.dateStart = moment().subtract(1, 'day').format('DD/MM/YYYY HH:mm:ss')
    Chart.Legend.prototype.afterFit = function() {
      this.height = this.height + 50;
    }
    this.orgnlDateStart = this.dateStart
    this.listTitle = this.$i18n.t('Webheader.vopMessage')
    this.activateSpinnerVopHistory = true
    this.activateSpinnerVopMessage = true
    this.activateSpinnerVopResponse = true
    this.getVopHistory()
    this.getVopMessage()
    this.getVopResponse()

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  watch: {
    tabName(newVal) {
      this.$nextTick(() => {
        this.onTabChange(newVal)
      })
    }
  },
  methods: {
    applyFilter() {
      this.activateSpinnerVopHistory = true
      this.activateSpinnerVopMessage = true
      this.activateSpinnerVopResponse = true
      this.getVopHistory()
      this.getVopMessage()
      this.getVopResponse()
    },
    arrayBufferToBase64(buffer) {
      let binary = ''
      let bytes = new Uint8Array(buffer)
      let length = bytes.length
      for (let i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary)
    },
    clearFilterFields() {
      this.StatusType = this.orgnlStatusType
      this.dateStart = this.orgnlDateStart
      this.dateEnd = this.orgnlDateEnd
      // this.applyFilter()
    },
    extractXLSX() {
      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))

      let wb = XLSX.utils.book_new()

      if (this.listItemsResponse.length > 0) {
        let responseData = []
        responseData.push([this.$t('common.monitoring.status'), this.$t('common.monitoring.nb_result')])

        this.listItemsResponse.forEach(result => {
          let statusCode = {
            "MTCH": "Match",
            "NMTC": "No Match",
            "CMTC": "Close Match",
            "NOAP": "Not Applicable",
            "": this.$t('tracking.no_result')
          }[result.Status] || result.Status

          responseData.push([statusCode, result.NbVopResponse])
        })

        let ws1 = XLSX.utils.aoa_to_sheet(responseData)
        XLSX.utils.book_append_sheet(wb, ws1, this.$t('common.monitoring.distribution_vop_response_status').substring(0, 31))
      }

      if (this.listItemsHistory.length > 0) {
          let historyData = []
          historyData.push([this.$t('common.monitoring.processing_step'), this.$t('common.monitoring.time_ms')])

          let connectorDurations = {}
          let countValue = {}

          this.listItemsHistory.forEach(result => {
              let connector = result.Connector
              let timeDiff = Number(result.TimeDiffMicroseconds) || 0

              if (connectorDurations[connector] !== undefined) {
                  connectorDurations[connector] += timeDiff
                  countValue[connector]++
              } else {
                  connectorDurations[connector] = timeDiff
                  countValue[connector] = 1
              }
          })

          for (let key in countValue) {
              connectorDurations[key] /= countValue[key]
          }

          Object.keys(connectorDurations).forEach(connector => {
              let connectorLabel = this.$t('common.monitoring.' + connector.replace(/\s+/g, ''))
              let averageTimeMs = Number((connectorDurations[connector] * 1000).toFixed(2))

              historyData.push([connectorLabel, averageTimeMs + ' (ms)'])
          })

          let ws2 = XLSX.utils.aoa_to_sheet(historyData)

          let sheetName = this.$t('common.monitoring.time_distribution_by_processing_connector').substring(0, 31)

          XLSX.utils.book_append_sheet(wb, ws2, sheetName)
      }

      if (this.listItemsMessage.length > 0) {
        let messageData = []
        messageData.push([this.$t('common.monitoring.status'), this.$t('common.monitoring.nb_result')])

        this.listItemsMessage.forEach(result => {
          if (result.OK) messageData.push([this.$t('common.monitoring.success'), result.OK])
          if (result.KO) messageData.push([this.$t('common.monitoring.technical_failure'), result.KO])
        })

        let ws3 = XLSX.utils.aoa_to_sheet(messageData)
        XLSX.utils.book_append_sheet(wb, ws3, this.$t('common.monitoring.distribution_of_requests').substring(0, 31))
      }

      if (this.listItemsHistory.length > 0) {
        let avgDurationData = []
        avgDurationData.push([this.$t('common.monitoring.date_time'), this.$t('common.monitoring.processing_step'), this.$t('common.monitoring.time_ms')])

        this.listItemsHistory.forEach(result => {
          let formattedHour = moment.utc(result.Hour).local().format('DD/MM/YYYY HH:mm:ss')
          let timeDiffInMs = Number((result.TimeDiffMicroseconds * 1000).toFixed(2))
          let connectorLabel = this.$t('common.monitoring.' + result.Connector.replace(/\s+/g, ''))
          avgDurationData.push([formattedHour, connectorLabel, timeDiffInMs + ' (ms)'])
        })

        let ws4 = XLSX.utils.aoa_to_sheet(avgDurationData)
        XLSX.utils.book_append_sheet(wb, ws4, this.$t('common.monitoring.average_duration_per_processing_step_messages').substring(0, 31))
      }

      this.$f7.hidePreloader()
      let wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      let linkSource = 'data:application/octet-stream;base64,' + this.arrayBufferToBase64(wbout)
      let downloadLink = document.createElement('a')
      let today = moment().unix()
      let fileName = this.$t('common.monitoring.statistics') + '_' + today + '.xlsx'

      if (this.$f7.device.os === 'android' || this.$f7.device.os === 'ios') {
        downloadFileWithDefinedHeaders(this, fileName, linkSource)
      } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      }

      this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
    },
    generateLineChartData(vopHistoryData) {
      const datasets = {}

      vopHistoryData.forEach((item) => {
        const connector = item.Connector
        const deltaTime = Number(item.TimeDiffMicroseconds) * 1000 || 0

        if (!datasets[connector]) {
          datasets[connector] = {
            label: this.$t('common.monitoring.' + connector.replace(' ', '')),
            data: new Array(this.lineChartLabels.length).fill(0),
            borderColor: this.getCustomColor(connector),
            backgroundColor: this.getCustomColor(connector, 0.8),
            fill: false,
          }
        }

        const hourIndex = this.lineChartLabels.indexOf(moment.utc(item.Hour).local().format('DD/MM/YYYY HH:mm:ss'))
        if (hourIndex !== -1) {
          datasets[connector].data[hourIndex] += deltaTime
        }
      })

      this.lineChartData = {
        labels: this.lineChartLabels,
        datasets: Object.values(datasets),
      }

      this.$nextTick(() => {
        this.$refs.lineChart &&
          this.$refs.lineChart.renderChart(
            this.lineChartData,
            this.chartOptionsLine
          )
      })
    },
    generatePieChartDataConnector(vopHistoryData) {
      let connectorDurations = {}
      let countValue = {}

      vopHistoryData.forEach((item) => {
        let connector = item.Connector
        let timeDiff = Number(item.TimeDiffMicroseconds) || 0
        if (connectorDurations[connector] !== undefined) {
          connectorDurations[connector] += timeDiff
          countValue[connector]++
        } else {
          connectorDurations[connector] = timeDiff
          countValue[connector] = 1
        }
      })
      for (let key in countValue) {
        connectorDurations[key] /= countValue[key]
      }

      let labels = Object.keys(connectorDurations).map((label) => this.$t('common.monitoring.' + label.replace(' ', '')) )
      let durations = Object.values(connectorDurations).map((duration) => Number((duration * 1000).toFixed(2)))
      let colors = Object.keys(connectorDurations).map((label) => this.getCustomColor(label, 0.8))

      this.pieChartDataConnector = {
        labels: labels,
        datasets: [
          {
            data: durations,
            backgroundColor: colors,
            datalabels: {
              formatter: (value, ctx) => {
                return `${value} (ms)`
              },
              color: "#000",
              font: {
                weight: "bold",
              },
              anchor: 'end',
              align: 'end',
              clamp: true,
            },
          },
        ],
      }

      this.$nextTick(() => {
        this.$refs.pieChartConnector &&
          this.$refs.pieChartConnector.renderChart(
            this.pieChartDataConnector,
            this.chartOptionsConnector
          )
      })
    },
    generatePieChartDataStatus(vopResponseData) {
      let filteredResponses = vopResponseData.filter((item) => item.Status)

      let statusCounts = {
        MATCH: 0,
        NOMATCH: 0,
        CLOSEMATCH: 0,
        NOAP: 0
      }
      filteredResponses.forEach((item) => {
        switch (item.Status) {
          case 'MTCH':
            statusCounts.MATCH = parseInt(item.NbVopResponse)
            break
          case 'NMTC':
            statusCounts.NOMATCH = parseInt(item.NbVopResponse)
            break
          case 'CMTC':
            statusCounts.CLOSEMATCH = parseInt(item.NbVopResponse)
            break
          case 'NOAP':
            statusCounts.NOAP = parseInt(item.NbVopResponse)
            break
          default:
            break
        }
      })
      let colors = [
        this.getCustomColor('MTCH', 0.8),
        this.getCustomColor('NMTC', 0.8),
        this.getCustomColor('CMTC', 0.8),
        this.getCustomColor('NOAP', 0.8),
      ]

      this.pieChartDataStatus = {
        labels: ['Match', 'No Match', 'Close Match', 'Not Applicable'],
        datasets: [
          {
            data: [
              statusCounts.MATCH,
              statusCounts.NOMATCH,
              statusCounts.CLOSEMATCH,
              statusCounts.NOAP,
            ],
            backgroundColor: colors,
          },
        ],
      }
      this.$nextTick(() => {
        this.$refs.pieChartStatus &&
          this.$refs.pieChartStatus.renderChart(
            this.pieChartDataStatus,
            this.chartOptionsStatus
          )
      })
    },
    generatePieChartDataRequest(vopMessageData) {
      let colors = [
        this.getCustomColor('MTCH', 0.8),
        this.getCustomColor('NMTC', 0.8)
      ]

      this.pieChartDataRequest = {
        labels: [
          this.$t("common.monitoring.success"),
          this.$t("common.monitoring.technical_failure"),
        ],
        datasets: [
          {
            data: [parseInt(vopMessageData[0].OK), parseInt(vopMessageData[0].KO)],
            backgroundColor: colors,
          },
        ],
      }

      this.$nextTick(() => {
        this.$refs.pieChartRequest &&
          this.$refs.pieChartRequest.renderChart(
            this.pieChartDataRequest,
            this.chartOptionsRequest
          )
      })
    },
    getCustomColor(key, alpha = 1) {
      let r, g, b
      r = Math.floor(Math.random() * 256)
      g = Math.floor(Math.random() * 256)
      b = Math.floor(Math.random() * 256)
      switch (key) {
        case 'CMTC': // Orange vif
          r = 230;
          g = 159;
          b = 0;
          break;
        case 'connector 1': // Violet moyen
          r = 117;
          g = 112;
          b = 179;
          break;
        case 'connector 2': // Bleu clair
          r = 86;
          g = 180;
          b = 233;
          break;
        case 'connector 3': // Gris neutre
        case 'NOAP': // Gris neutre
          r = 153;
          g = 153;
          b = 153;
          break;
        case 'connector 4': // Vert turquoise clair
          r = 0;
          g = 158;
          b = 115;
          break;
        case 'connector 5': // Bleu profond
          r = 0;
          g = 114;
          b = 178;
          break;
        case 'connector 6': // Brun chaud
          r = 213;
          g = 94;
          b = 0;
          break;
        case 'connector 7': // Cyan clair
          r = 0;
          g = 204;
          b = 204;
          break;
        case 'MTCH': // Vert foncé
          r = 0;
          g = 143;
          b = 57;
          break;
        case 'NMTC': // Rouge atténué
          r = 204;
          g = 0;
          b = 0;
          break;
        case '': // Vide ou non spécifié
          break;
      }
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    },
    getRandomColor(alpha = 1) {
      const r = Math.floor(Math.random() * 256)
      const g = Math.floor(Math.random() * 256)
      const b = Math.floor(Math.random() * 256)
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    },
    getVopHistory() {
      let that = this
      let params = { StatusType: this.StatusType, DateStart: this.dateStart != '' ? moment(this.dateStart, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '', DateEnd: this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '' }
      this.$engine.monitoring.vopHistory.fetch(params).then((resp) => {
        let vopHistoryList = {}

        vopHistoryList = resp.data.VopHistory

        this.lineChartLabels = [...new Set(vopHistoryList.map(item => moment.utc(item.Hour).local().format('DD/MM/YYYY HH:mm:ss')))].sort()

        that.updateVopHistory(vopHistoryList)
        that.generateLineChartData(vopHistoryList)
        that.generatePieChartDataConnector(vopHistoryList)

        this.$f7.pullToRefreshDone()
        that.activateSpinnerVopHistory = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getVopMessage () {
      let that = this
      let params = {
        name: this.elementSearchedVopMessage,
        StatusType: this.StatusType,
        DateStart: this.dateStart != '' ? moment(this.dateStart, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        DateEnd: this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      }
      this.$engine.monitoring.vopMessage.fetch(params).then((resp) => {
        let vopMessageList = {}

        vopMessageList = resp.data.VopMessage

        that.updateVopMessage(vopMessageList)
        that.generatePieChartDataRequest(vopMessageList)

        this.$f7.pullToRefreshDone()
        that.activateSpinnerVopMessage = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getVopResponse() {
      let that = this
      let params = { name: this.elementSearchedVopResponse, DateStart: this.dateStart != '' ? moment(this.dateStart, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '', DateEnd: this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '' }
      this.$engine.monitoring.vopResponse.fetch(params).then((resp) => {
        let vopResponseList = {}

        vopResponseList = resp.data.VopResponse

        that.updateVopResponse(vopResponseList)
        that.generatePieChartDataStatus(vopResponseList)

        this.$f7.pullToRefreshDone()
        that.activateSpinnerVopResponse = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinnerVopHistory = true
      this.activateSpinnerVopMessage = true
      this.activateSpinnerVopResponse = true
      this.getVopHistory()
      this.getVopMessage()
      this.getVopResponse()
    },
    onTabChange(index) {
      const charts = [
        {
          ref: this.$refs.pieChartStatus,
          data: this.pieChartDataStatus,
          options: this.chartOptionsStatus
        },
        {
          ref: this.$refs.pieChartConnector,
          data: this.pieChartDataConnector,
          options: this.chartOptionsConnector
        },
        {
          ref: this.$refs.pieChartRequest,
          data: this.pieChartDataRequest,
          options: this.chartOptionsRequest
        },
        {
          ref: this.$refs.lineChart,
          data: this.lineChartData,
          options: this.chartOptionsLine
        }
      ]

      const chart = charts[index]

      if (chart && chart.ref) {
        chart.ref.renderChart(chart.data, chart.options)
      }

      // Gérer le spinner si nécessaire
      // this.$nextTick(() => {
      //   this.activateSpinner = false
      // })
    },
    updateVopHistory(vopHistoryList) {
      this.listItemsHistory = vopHistoryList
    },
    updateVopMessage(vopMessageList) {
      this.listItemsMessage = vopMessageList
    },
    updateVopResponse(vopResponseList) {
      this.listItemsResponse = vopResponseList
    }
  }
}
</script>

<style scoped>

@media (max-width: 1400px) {
  .responsive-button {
    min-height: 100px;
  }
}

@media (max-width: 1400px) {
  .responsive-button2 {
    max-height: 70px;
  }
}
</style>
